import type { IconSvgObject } from './types';

const HonourStarIcon: IconSvgObject = [
  ["path", { d: "M2.5 3.00098H21.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M4.5 2.99976V15.9806L11.9363 20.9827C11.97 21.0054 12.0141 21.0054 12.0478 20.9828L19.5 15.9806V2.99976", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M9.66667 14L12 13.087L14.3333 14L14.0417 11.5652L15.5 9.73913L13.4583 9.13043L12 7L10.5417 9.13043L8.5 9.73913L9.95833 11.5652L9.66667 14Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.55", key: "2" }]
];

export default HonourStarIcon;
